module.exports = __webpack_public_path__ + "img/vartext2.c14a3c6a.svg";